/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const voicePreferencesSpeechSpeedMin = 0.25;
export const voicePreferencesSpeechSpeedMax = 1.5;

export const VoicePreferences = zod.object({
  speechSpeed: zod
    .number()
    .min(voicePreferencesSpeechSpeedMin)
    .max(voicePreferencesSpeechSpeedMax)
    .describe(
      'How fast the realtime voice agent speaks: a multiplier from 0.25 to 1.5, where 1.0 is normal.',
    ),
});

export type VoicePreferences = zod.input<typeof VoicePreferences>;
export type VoicePreferencesOutput = zod.output<typeof VoicePreferences>;
